import type { MediaEvent } from './agent'

export class Queue {
  private stack: any
  private maxLength: number

  constructor(maxLength: number = 0) {
    this.stack = []
    this.maxLength = maxLength
  }

  public getLength() {
    return this.stack.length
  }

  public isEmpty(): boolean {
    return this.stack.length === 0
  }

  public enqueue(item: MediaEvent) {
    // If maxItems is set, remove the first item of the stack.
    if (this.maxLength > 0 && this.stack.length === this.maxLength) {
      this.stack.shift()
    }

    this.stack.push(item)
  }

  public dequeue(): MediaEvent[] {
    return this.stack.splice(0)
  }

  // Put back items which have already been dequeued (e.g. a failed report).
  // They are older than what the queue currently holds, so they go back in
  // front of it to keep the events chronologically ordered.
  public requeue(items: MediaEvent[]) {
    if (items.length === 0) {
      return
    }

    this.stack.unshift(...items)

    // If maxLength is set, drop the oldest items overflowing the queue.
    if (this.maxLength > 0 && this.stack.length > this.maxLength) {
      this.stack.splice(0, this.stack.length - this.maxLength)
    }
  }

  public upsertLast(item: MediaEvent) {
    if (this.isEmpty()) {
      return
    }

    return (this.stack[this.stack.length - 1] = item)
  }

  public peekLast(): MediaEvent | undefined {
    if (this.isEmpty()) {
      return undefined
    }

    return this.stack[this.stack.length - 1]
  }
}
